"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.expand = void 0;
var _actionGenerator = require("../../types/redux/actionGenerator");
var _types = require("./types");
const expand = exports.expand = (0, _actionGenerator.actionGenerator)(_types.ESocialsActionTypes.Expand);